export const CheckAccessHelper = (userRoles: string[], referenceRoles: string[]) => {
  return !!userRoles.find((userEl) => {
    return !!~referenceRoles.indexOf(userEl)
  })
}
